import { RestRequest } from "@Utils";
import { IChatSession, IMessage } from "atlas-shared";

export const postMessage = (message: IMessage): Promise<IMessage> => {
  return RestRequest.post(`api/v1/chat/message`, message);
};

export const getChatSessionsByConversationId = (
  conversationId: number
): Promise<IChatSession[]> => {
  return RestRequest.get(`/api/v1/chat_session/conversation/${conversationId}`);
};

export const endChatSession = (sessionId: string): Promise<IChatSession> => {
  return RestRequest.post(`/api/v1/chat_session/end`, {
    chatSession: { sessionId: sessionId },
  });
};
